// TODO: [A2-4801] consider moving this to core if web and mobile menu types are aligned.
export enum OptionsMenuTypes {
  AudioItem = 0,
  Location = 1,
  MyAudio = 2,
  MyAudioExclusiveStation = 3,
  MyAudioPodcast = 4,
  MyAudioQueue = 5,
  MyAudioRadioShow = 6,
  MyAudioRadioStation = 7,
  MyAudioTopic = 8,
  PodcastEntity = 9,
  PodcastEpisode = 10,
  RadioShowClip = 11,
  RadioShowEntity = 12,
  RadioShowEpisode = 13,
  RadioShowSegment = 14,
  RadioStationEntity = 15,
  RecentExclusiveStation = 16,
  RecentPodcast = 17,
  RecentRadioShow = 18,
  RecentRadioStation = 19,
  SearchPodcastEntity = 20,
  FullPlayerExclusiveStation = 21,
  FullPlayerStation = 22,
  FullPlayerBroadcastEpisode = 23,
  FullPlayerPodcastEpisode = 24,
  TopicEntity = 25,
  ContinueListeningPodcastEpisode = 26,
  ContinueListeningBroadcastEpisode = 27,
  SearchPodcastEpisode = 28,
  SearchStation = 29,
  BroadcastEpisode = 30,
  Playlist = 31,
  StandaloneChapter = 32,
  ContactSheet = 33,
}
